import { FADE_DURATION } from "./consts";

/**
 * If the "next" button is hit, manually fade out the audio.
 *
 * @param    {HTMLElement} video HTML5 video tag.
 * @param    {number} duration how long we want the fade to last
 */
export default function fadeOutAudio(video, duration = FADE_DURATION) {
  const steps = 10;
  const time = duration / steps;
  let loop = steps;

  while (loop--) {
    setTimeout(() => {
      const newVolume = video.volume - 1 / steps;

      video.volume = newVolume > 0 ? newVolume.toFixed(2) : 0;
    }, duration - time * loop);
  }
}
